import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { SelectDenominationButton } from '@features/denomination/select';
import { checkIsDenominationSoldOut, DenominationAmountByServiceIdType, DenominationCard } from '@entities/denomination';
import { getClientBaseAmount } from '@features/payment/payment-form';
import { checkIsServiceNonTopUp, checkIsWithPercentFee, TspPageDenomination, TspPagePayee, useCyberStore } from '@entities/tsp';
import { toPriceFormat } from '@shared/lib/money';
interface DenominationListProps {
  payee: TspPagePayee;
  denominations: TspPageDenomination[];
  pricesByServiceId: DenominationAmountByServiceIdType;
}
const DenominationList: FC<DenominationListProps> = ({
  payee,
  denominations,
  pricesByServiceId
}) => {
  const {
    paymentMethod
  } = useCyberStore();
  const isPubgMobile = payee.features?.tsp_url === 'pubg-mobile';
  const isNonTopUp = checkIsServiceNonTopUp(true, payee);
  // const isNonTopUp = checkisservi(true, payee)

  return <DenominationListWrapper>
      {denominations.map(denomination => <DenominationCard key={denomination.serviceId} payee={payee} denomination={denomination} isSoldOut={checkIsDenominationSoldOut(pricesByServiceId?.[denomination.serviceId])} button={<SelectDenominationButton isSoldOut={checkIsDenominationSoldOut(pricesByServiceId?.[denomination.serviceId])} payee={payee} denomination={denomination} price={toPriceFormat(getClientBaseAmount(pricesByServiceId?.[denomination.serviceId], isPubgMobile, isNonTopUp, checkIsWithPercentFee(payee), paymentMethod), {
      trimIfInteger: true
    })} />} />)}
    </DenominationListWrapper>;
};
export default DenominationList;
const DenominationListWrapper = /*#__PURE__*/styled('div')({
  name: "DenominationListWrapper",
  class: "d12avxy4",
  propsAsIs: false
});

require("./DenominationList.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./DenominationList.tsx");